import Box from "@mui/material/Box";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import KhattabaMenu from "./KhattabaAdmin";

// Khattaba-only client: the header menu always shows the khattaba menu.
const HeaderMenu = withLiteObserverAndTheme(() => {
  return (
    <Box
      sx={{
        flex: 1,
        minWidth: 0,
        display: "flex",
        alignSelf: "stretch"
      }}
    >
      <KhattabaMenu />
    </Box>
  );
});

export default HeaderMenu;
